<!--
/*******************************************************************************
*@ 컴포넌트명   : CalendarInq.vue
*@ 컴포넌트설명 : 달력으로 거래내역 조회
*@ 사용전문     : RBF0404A40 - 예금계좌거래내역
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <account-search-box
      ref="searchBox"
      v-show="!transDetailShow"
      in-acn-knd="0"
      in-acn-dtl-knd="0"
      :default-acno="initAcno"
      @search="calendarInqFn"
    />
    <calendar
      ref="cal"
      :value.sync="date"
      :auto-open="true"
      :attrs="attrs"
      @changeMmYyyy="changeMmYyyy"
      @dayClick="dayClick"
    />
    <!-- 페이드인 기능 : fadein -->
    <transition>
      <div v-if="totalAmtShow" class="calendar-search--detail">
        <div class="item">
          <div class="tit dot">{{ /*월 입금총액*/ $t("MINQ-02-02-01-05") }}</div>
          <div class="desc">
            <span class="exchange-unit">{{ this.RBF0404A40Month.cncycd }}</span>
            <span class="amount" v-html="getTotalDepositAmt"></span>
          </div>
        </div>
        <div class="item">
          <div class="tit dot">{{ /*월 출금총액*/ $t("MINQ-02-02-01-06") }}</div>
          <div class="desc">
            <span class="exchange-unit">{{ this.RBF0404A40Month.cncycd }}</span>
            <span class="amount" v-html="getTotalWithdrawalAmt"></span>
          </div>
        </div>
      </div>
    </transition>
    <!-- end -->
    <!-- 입출금 내역 리스트 -->
    <!-- 계좌정보 없이 계좌 내역만 나올 경우 breakdown-height -->

    <dropdown
      :opened.sync="transDetailShow"
      class="breakdown-height"
      @showAllRowCal="showAllRowCal"
    >
      <template #content>
        <common-grid
          ref="commonGrid"
          :list="RBF0404A40Date.dpstAcnGrid"
          :total-line-cnt="RBF0404A40Date.totalLineCnt"
        >
          <template v-slot:list="data">
            <!-- division -->
            <!-- 입금 -->
            <div class="item date">{{ $getGlobalDateFmt(data.row.tranYms) }}</div>
            <div class="item use">{{ $t(`${data.row.inotBasiSumryCd}_입출근거적요코드`) }}</div>

            <div
              class="item name"
              v-if="data.row.brncoInotDstcd == 10 ? 'deposit' : 'withdraw'"
            >{{ data.row.rmtancDrawe }}</div>
            <div class="item name" v-else>{{ data.row.rmtancDrawe }}({{ data.row.memo }})</div>

            <!-- 입금 : deposit, 출금 : withdraw  -->
            <template v-if="data.row.mnrcvAmt != '0'">
              <div class="item object" :class="{ deposit: true, withdraw: false }">
                <div class="tit">{{ /*입금액*/ $t("MINQ-02-03-03-29") }}</div>
                <div class="desc">
                  <span class="exchange-unit">{{ data.row.cncycd }}</span>
                  <span class="amount" v-html="$num(data.row.mnrcvAmt, null, true)"></span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="item object" :class="{ deposit: false, withdraw: true }">
                <div class="tit">{{ /*출금액*/ $t("MINQ-02-03-03-30") }}</div>
                <div class="desc">
                  <span class="exchange-unit">{{ data.row.cncycd }}</span>
                  <span class="amount" v-html="$num(data.row.drwotAmt, null, true)"></span>
                </div>
              </div>
            </template>

            <div class="item balance">
              <div class="tit">{{ /*잔액*/ $t("MINQ-02-03-03-31") }}</div>
              <div class="desc">
                <span class="exchange-unit">{{ data.row.cncycd }}</span>
                <span class="amount" v-html="$num(data.row.tranAfBal, null, true)"></span>
              </div>
            </div>
            <div class="item etc">
              <div
                class="tit"
                v-if="data.row.brncoInotDstcd == 10"
              >{{ /*적요*/ $t("MINQ-02-03-03-27") }}</div>
              <div class="tit" v-else>{{ /*송금메모*/ $t("MINQ-02-03-03-26") }}</div>
              <div class="desc">{{ data.row.rmark }}</div>
            </div>

            <!--// 입금 end -->
            <!-- division -->
          </template>
        </common-grid>
      </template>
    </dropdown>

    <!--// 입출금 내역 리스트 end -->
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import AccountSearchBox from "@/components/page/common/AccountSearchBox";
import CommonGrid from "@/components/page/common/CommonGrid";

export default {
  components: { AccountSearchBox, CommonGrid },
  data() {
    return {
      RBF0404A40: {}, //거래내역조회
      RBF0404A40Month: {}, //월별 거래내역조회 결과
      sucType: "", //전문호출 구분값
      firstSearch: true, // 최초 달력조회 진입여부
      fromDate: "",
      toDate: "",
      date: "",
      attrs: [
        {
          key: "today",
          highlight: true,
          dot: true,
        },
        {
          dot: {
            style: {
              background: "#0091ff",
            },
          },
          dates: [],
        },
        {
          dot: {
            style: {
              background: "#f47a00",
            },
          },
          dates: [],
        },
      ],
      transDetailShow: false,
    };
  },

  computed: {
    ...mapFields(["lang", "siteCode"]),
    ...mapFields("accounts/calendarInq", ["calendarInq", "totalAmtShow", "RBF0404A40Date"]),
    ...mapFields("accounts", ["initAcno"]),

    getTotalDepositAmt() {
      //총 입금금액
      if (this.RBF0404A40Month.dpstAcnGrid) {
        if (this.RBF0404A40Month.dpstAcnGrid.length > 0) return this.$num(this.RBF0404A40Month.dpstAcnGrid[0].totalMnrcvAmt, null, true);
      }
      return this.$num(0, null, true);
    },
    getTotalWithdrawalAmt() {
      //총 출금금액
      if (this.RBF0404A40Month.dpstAcnGrid) {
        if (this.RBF0404A40Month.dpstAcnGrid.length > 0) return this.$num(this.RBF0404A40Month.dpstAcnGrid[0].totalDrwotAmt, null, true);
      }
      return this.$num(0, null, true);
    },
  },
  created() {
    this.calendarInq.acno = this.initAcno.acno;
  },
  beforeDestroy() {}, //페이지 이동 직전 store 초기화
  methods: {
    changeMmYyyy(data) {
      //store set
      this.RBF0404A40Call(this.calendarInq.acno, "1", data.fromDate, data.toDate, "0");
      this.totalAmtShow = true; //총합 계산 패널 show
      if (this.transDetailShow) {
        // 날짜별 detail 화면 안에서 월을 바꿀 경우
        this.$refs.cal.allRowShow(); //해당 월 전체 표시
        this.transDetailShow = false; // 날짜별 detail show off
      }
    },
    dayClick(day) {
      this.totalAmtShow = !this.totalAmtShow; // 총합 계산 패널 close
      if (this.transDetailShow) {
        //거래내역 detail show일 경우
        this.totalAmtShow = false;
      }
      this.RBF0404A40Call(this.calendarInq.acno, "1", day, day, "1");
    },

    calendarInqFn(srchParam, acnoParam) {
      let list = [];
      this.initAcno = acnoParam; //index.js에 기간별조회와 같이 쓰는 acno
      this.calendarInq.acno = acnoParam.acno;
      if (!this.firstSearch) {
        //최초 조회가 아니고, 계좌를 변경한 거래시
        this.$refs.cal.moveToday(); //계좌변경시 현재 년월로 조회
      }
      this.firstSearch = false;

      this.$set(this.attrs[1], "dates", list); //입금 거래 날짜 초기화
      this.$set(this.attrs[2], "dates", list); //출금 거래 날짜 초기화
    },

    /** 입금날짜 판별 함수 */
    checkDeposit(val) {
      let list = [];
      if (!this.RBF0404A40Month.dpstAcnGrid) return;

      for (let i = 0; i < this.RBF0404A40Month.dpstAcnGrid.length; i++) {
        if (
          val == this.RBF0404A40Month.dpstAcnGrid[i].tranYmd.substr(4, 2) &&
          this.RBF0404A40Month.dpstAcnGrid[i].brncoInotDstcd == 10 &&
          this.RBF0404A40Month.dpstAcnGrid[i].mnrcvAmt > 0
        ) {
          list.push(this.$getStringToDate(this.RBF0404A40Month.dpstAcnGrid[i].tranYmd));
          this.$set(this.attrs[1], "dates", list); //입금날짜 저장
        }
      }
      return false;
    },

    /** 출금날짜 판별 함수 */
    checkWithdrawal(val) {
      let list = [];
      if (!this.RBF0404A40Month.dpstAcnGrid) return;
      for (let i = 0; i < this.RBF0404A40Month.dpstAcnGrid.length; i++) {
        if (
          val == this.RBF0404A40Month.dpstAcnGrid[i].tranYmd.substr(4, 2) &&
          this.RBF0404A40Month.dpstAcnGrid[i].brncoInotDstcd != 10 &&
          this.RBF0404A40Month.dpstAcnGrid[i].drwotAmt > 0
        ) {
          list.push(this.$getStringToDate(this.RBF0404A40Month.dpstAcnGrid[i].tranYmd));
          this.$set(this.attrs[2], "dates", list); //출금날짜 저장
        }
      }
      return false;
    },
    showAllRowCal() {
      //거래상세내역 close 시 전체달력 조회
      if (this.totalAmtShow) {
        this.$refs.cal.allRowShow();
      }
      return true;
    },

    /** 거래내역 조회 전문 call
      inqType : 0 // 월별거래내역
                1 // 일별거래내역
      */
    RBF0404A40Call(acno, actype, fromDate, toDate, inqType) {
      this.month = fromDate.substr(4, 2);

      this.RBF0404A40.requestData = {
        acno: this.calendarInq.acno, //계좌번호
        tranStartYmd: fromDate, //거래시작일
        tranEndYmd: toDate, //거래종료일
        brncoInotDstcd: "00", //입출금구분 00:전체 10:입금
        resultSeq: "01", //결과순서
        dmndPageNo: 0, //요청페이지번호
        pageLineCnt: "1000", //페이지라인
      };

      let endpoint = "/account/trnhis";

      if (actype == 1 || actype == 2) endpoint += "/OndmdTrnhis";
      else if (actype == 3) endpoint += "/DfstlFxdepTrnhis";
      else if (actype == 4) endpoint += "/InstypFxdepTrnhis";

      this.sucType = ""; // 월별/일별 전문 suc 구분
      this.sucType = inqType;

      this.$post(
        endpoint,
        this.RBF0404A40.requestData, //input값 요청할데이터
        this.RBF0404A40Suc, //호출 성공시 실행하는 콜백
        this.RBF0404A40Fail, //실패
        this.RBF0404A40Final, //final
      );
    },

    /** 월별 거래내역조회 결과  */
    RBF0404A40Suc(res) {
      if (this.sucType == 0) {
        //월별 거래내역조회 결과
        this.RBF0404A40Month = {};

        this.RBF0404A40Month = {
          ...res.outItem,
        };
        this.checkDeposit(this.month);
        this.checkWithdrawal(this.month);
      } else if (this.sucType == 1) {
        //일별 거래내역조회 결과
        this.RBF0404A40Date = {}; //초기화

        //일별
        this.RBF0404A40Date = {
          ...res.outItem,
        };
        if (!this.transDetailShow) {
          this.transDetailShow = true;
        }
        // this.$refs.commonGrid.changeList(this.RBF0404A40Date.dpstAcnGrid); //commonGrid 데이터 변경 시 호출
      }
      if (this.$refs.cal) {
        this.$refs.cal.refresh(); // 캘린더에 날짜 표시
      }
      // this.inqType = "";
    },

    RBF0404A40Fail() {},
    RBF0404A40Final() {
      this.inqType = "";
      if (this.transDetailShow) {
        this.$refs.commonGrid.changeList(this.RBF0404A40Date.dpstAcnGrid); //commonGrid 데이터 변경 시 호출
      }
    },
  },
};
</script>
